var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFullSun = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.049 -2.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.881,
    height: 1.762,
    transform: "translate(50.648 2.41)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.881,
    height: 1.762,
    transform: "translate(47.208 3.498) rotate(-30)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.884,
    height: 1.768,
    transform: "translate(44.745 6.25) rotate(-60.113)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.762,
    height: 0.881,
    transform: "translate(44.049 8.929)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.762,
    height: 0.881,
    transform: "translate(44.693 12.5) rotate(-30)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.762,
    height: 0.881,
    transform: "translate(47.135 15.288) rotate(-60)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.881,
    height: 1.762,
    transform: "translate(50.568 14.647)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.881,
    height: 1.762,
    transform: "translate(53.253 14.237) rotate(-30)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.881,
    height: 1.762,
    transform: "translate(55.405 12.44) rotate(-60)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.762,
    height: 0.881,
    transform: "translate(56.287 9.009)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.762,
    height: 0.881,
    transform: "translate(55.44 6.446) rotate(-30)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.762,
    height: 0.881,
    transform: "translate(53.32 4.624) rotate(-60)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.917,14.245a3.931,3.931,0,1,1,3.932-3.931A3.936,3.936,0,0,1,51.917,14.245Zm0-7.085a3.153,3.153,0,1,0,3.154,3.154A3.158,3.158,0,0,0,51.917,7.16Z",
    transform: "translate(-0.875 -0.883)",
    fill: "#ffbc3d"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFullSun);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/full-sun.a678a4e7f1a7991f88b38bf1ba471543.svg";